module.exports = __webpack_public_path__ + "static/media/29BDOS18.2a42fbc3.jpg";